import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import NotFound from "@/pages/NotFound";
import { resolveLegacyArticle } from "@/lib/seo/legacyRedirect.functions";

export const Route = createFileRoute("/_app/learn-articles/$slug")({
  loader: async ({ params }) => {
    const target = await resolveLegacyArticle({ data: params.slug });
    if (target) throw redirect({ to: "/article/$id", params: { id: target }, statusCode: 301 });
    throw notFound();
  },
  head: () => ({
    meta: [{ title: "Page Not Found" }, { name: "robots", content: "noindex" }],
  }),
  notFoundComponent: NotFound,
  component: NotFound,
});
